__turbopack_context__.v({
  "table": "portable-text-components-module__GFQShq__table",
  "tableWrapper": "portable-text-components-module__GFQShq__tableWrapper",
});
